import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AccountConfirmationContainer from '../containers/account_confirmation';
import MagicLinkContainer from '../containers/magic_link';
import AccountContainer from '../containers/account';
import DeleteAccountContainer from '../containers/delete_account';
import CreateAccountContainer from '../containers/create_account';
import LoginContainer from '../containers/login';
import MakePublicProfileContainer from '../containers/make_public_profile';
import MakePrivateProfileContainer from '../containers/make_private_profile';
import FollowRecommendationsFirstRunContainer from '../containers/follow_recommendations_first_run_container';
import FollowRecommendationsFirstRunCongratsContainer from '../containers/follow_recommendations_first_run_congrats_container';
import FollowRecommendationsContainer from '../containers/follow_recommendations';
import ProfileEditContainer from '../containers/profile_edit';
import NotificationPreferencesContainer from '../containers/notification_preferences';
import PointsBoardContainer from '../containers/points_board';

export default class Account extends React.Component {
  render() {
    return(
      <Switch>
        <Route path="/account/confirmation/:confirmation_token" component={ AccountConfirmationContainer } />
        <Route path="/account/magic_link/:token/go_to/:go_to" component={ MagicLinkContainer } />
        <Route path="/account/magic_link/:token" component={ MagicLinkContainer } />
        <Route path="/account/delete" component={ DeleteAccountContainer } />
        <Route path="/account/login" component={ LoginContainer } />
        <Route path="/account/create" component={ CreateAccountContainer } />
        <Route path="/account/recommend_people_to_follow_first_run_congrats" component={ FollowRecommendationsFirstRunCongratsContainer } />
        <Route path="/account/recommend_people_to_follow_first_run" component={ FollowRecommendationsFirstRunContainer } />
        <Route path="/account/recommend_people_to_follow" component={ FollowRecommendationsContainer } />
        <Route path="/account/make_profile" component={ MakePublicProfileContainer } />
        <Route path="/account/make_private_profile" component={ MakePrivateProfileContainer } />
        <Route path="/account/profile/edit" component={ ProfileEditContainer } />
        <Route path="/account/notification_preferences" component={ NotificationPreferencesContainer } />
        <Route path="/account/points_board" component={ PointsBoardContainer } />
        <Route path="/account" component={ AccountContainer } />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account.jsx